import * as exFormat from '../format';

// ----------------------------------------------------------------------------

function toBase64(str: string, config: Record<string, any> = {}): string {
    // Convert to Base64
    let base64 = window.btoa(str);

    // If using format
    if (config.format === true) {
        base64 = exFormat.base64(base64, config.type);
    }

    //
    return base64;
}

// ----------------------------------------------------------------------------

export default toBase64;
